<template>
  <transition name="popup">
    <div class="popup-container flex flex-center flex-column" v-if="showFlag">
      <!-- <div class="popup-content"> -->
        <div class="kuan-box" :class="[diyClass]">
          <button class="hide" @click="hideFn" v-if="rbtn === ''"></button>
          <slot></slot>
        </div>
      <!-- </div> -->
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Popup',
  props: {
    rbtn: {
      type: String,
      default: ''
    },
    diyClass: {
      type: String,
      default: 'kuan-1'
    }
  },
  data () {
    return {
      showFlag: false
    }
  },
  methods: {
    showFn () {
      this.showFlag = true
    },
    hideFn () {
      this.showFlag = false
    }
  }
}
</script>

<style scoped>
.popup-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 500;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: rgba(0, 0, 0, .3);
}
.kuan-box {
  position: relative;
  transition: transform .4s cubic-bezier(0.32, 0.08, 0.24, 1);
}
.kuan-1 {
  width: 5.9rem;
  min-height: 5.5rem;
  border: .08rem solid #fff;
  border-radius: .1rem;
  background-color: rgba(212, 84, 110, .9);
}
.hide {
  position: absolute;
  top: .15rem;
  right: .15rem;
  z-index: 20;
  width: .63rem;
  height: .63rem;
  background: url('../../assets/images/hide.png') center no-repeat;
  background-size: contain;
}
.popup-enter-active,
.popup-leave-active {
  transition: opacity .4s cubic-bezier(0.32, 0.08, 0.24, 1);
}
.popup-enter,
.popup-leave-to {
  opacity: 0;
}
.popup-enter .kuan-box,
.popup-leave-to .kuan-box {
  transform: translateY(100%);
}
</style>
